import React from 'react'
import { Button, Space, Tooltip, Typography } from 'antd'
import { PlusOutlined, SortAscendingOutlined } from '@ant-design/icons'

const { Title, Text } = Typography

interface RateSectionHeaderProps {
  onCreateRate: () => void
  isSortMode: boolean
  hasUnsavedRates: boolean
  onToggleSortMode: () => void
}

const RateSectionHeader: React.FC<RateSectionHeaderProps> = ({
  onCreateRate,
  isSortMode,
  hasUnsavedRates,
  onToggleSortMode,
}) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
    <div>
      <Title level={3} style={{ margin: 0 }}>Rate Details</Title>
      <Text type="secondary">Manage your Rates Multicontent</Text>
    </div>
    <Space>
      <Tooltip
        title={hasUnsavedRates && !isSortMode ? 'Some rates are not saved yet — click to see details' : undefined}
      >
        <Button
          icon={<SortAscendingOutlined />}
          type={isSortMode ? 'primary' : 'default'}
          onClick={onToggleSortMode}
        >
          Sort Order
        </Button>
      </Tooltip>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={onCreateRate}
        style={{ display: 'none' }}
      >
        Create Rate
      </Button>
    </Space>
  </div>
)

export default RateSectionHeader
